/**
 * Registration point for every chat message-block renderer this app ships.
 *
 * Imported for its SIDE EFFECT by `AIAssistantChat`, so the registry is
 * populated before the first message renders. Adding a block is: write the
 * renderer, register it here, add its type to `OWN_MESSAGE_BLOCK_TYPES` — the
 * drift test fails if the last step is forgotten.
 */

import { registerMessageBlock } from '@domains/aiAssistant/state/messageBlocks';
import { ChannelPickerBlock } from './ChannelPickerBlock';
import { ImportProgressBlock } from './ImportProgressBlock';
import { RulePreviewBlock } from './RulePreviewBlock';
import { AutomationDraftBlock } from './AutomationDraftBlock';
import { AutomationDraftBlockConnected } from './AutomationDraftBlockConnected';

registerMessageBlock( 'channel-picker', ChannelPickerBlock );
registerMessageBlock( 'import-progress', ImportProgressBlock );
// String kept in sync with `RULE_PREVIEW_BLOCK_TYPE`, the constant the stream
// adapter mints the block with — registering by the constant would import the
// domain module into the registration site for one literal.
registerMessageBlock( 'rule-preview', RulePreviewBlock );
// Kept in sync with `AUTOMATION_DRAFT_BLOCK_TYPE`, same reasoning as above.
// The CONNECTED wrapper is what gets registered: the presentational block takes
// its submit handler as a prop, so registering it bare left Enviar wired to
// nothing (TV1-2423). The wrapper's whole job is one call to
// `POST /ai-assistant/automation-requests/submit`.
registerMessageBlock( 'automation-draft', AutomationDraftBlockConnected );

export {
  ChannelPickerBlock,
  ImportProgressBlock,
  RulePreviewBlock,
  AutomationDraftBlock,
  AutomationDraftBlockConnected
};
export type { ChannelPickerPayload } from './ChannelPickerBlock';
export type { ImportProgressPayload } from './ImportProgressBlock';
export type { RulePreviewBlockPayload } from './RulePreviewBlock';
export type { AutomationDraftBlockPayload } from './AutomationDraftBlock';
